<h2 mat-dialog-title>Point Of Contact</h2>
<mat-dialog-content>
  <form #pocForm="ngForm" autocomplete="off">
    <div class="row">
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Name</mat-label>
          <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="doctorPoc.name" required>
          <mat-error *ngIf="name.invalid && name.touched">Required</mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Email</mat-label>
          <input type="text" matInput name="email" [(ngModel)]="doctorPoc.email">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Mobile</mat-label>
          <input type="text" matInput name="mobile" [(ngModel)]="doctorPoc.mobile">
        </mat-form-field>
      </div>
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Designation</mat-label>
          <input type="text" matInput name="designation" [(ngModel)]="doctorPoc.designation">
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-stroked-button (click)="close()">Discard</button>
  <button type="button" mat-flat-button color="primary" (click)="savePoc(pocForm.valid)">Add</button>
</mat-dialog-actions>